import { render, staticRenderFns } from "./LayoutDefault.global.vue?vue&type=template&id=24c094f4&scoped=true&lang=pug&"
import script from "./LayoutDefault.global.vue?vue&type=script&lang=ts&"
export * from "./LayoutDefault.global.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutDefault.global.vue?vue&type=style&index=0&id=24c094f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c094f4",
  null
  
)

export default component.exports